enum UnavailableOnlineBehaviourEnum {
	blockPurchase = 'blockPurchase',
	continueByShoppingList = 'continueByShoppingList'
}

export default UnavailableOnlineBehaviourEnum;
